import { merchantApi } from '@/config/axios'

// ========== 商家端订单管理 API ==========

// 订单分页
export const getOrderPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/order/page', params })
}

// 订单详情
export const getOrder = (id: number) => {
  return merchantApi.get({ url: `/merchant-api/order/get-detail?id=${id}` })
}

// 发货（须传物流公司编号 logisticsId；0 表示无需发货）
export const deliveryOrder = (data: { id: number; logisticsId: number; logisticsNo?: string }) => {
  return merchantApi.put({ url: '/merchant-api/order/delivery', data })
}

/** 自提核销（按订单 id） */
export const pickUpOrder = (id: number) => {
  return merchantApi.put({ url: `/merchant-api/order/pick-up-by-id?id=${id}` })
}

/** 自提核销（按核销码） */
export const pickUpOrderByVerifyCode = (pickUpVerifyCode: string) => {
  return merchantApi.put({
    url: '/merchant-api/order/pick-up-by-verify-code',
    params: { pickUpVerifyCode }
  })
}

/** 按核销码查本店订单 */
export const getOrderByPickUpVerifyCode = (pickUpVerifyCode: string) => {
  return merchantApi.get({
    url: '/merchant-api/order/get-by-pick-up-verify-code',
    params: { pickUpVerifyCode }
  })
}

// 修改备注
export const updateRemark = (data: { id: number; remark: string }) => {
  return merchantApi.put({ url: '/merchant-api/order/update-remark', data })
}

// 修改价格
export const updatePrice = (data: { id: number; adjustPrice: number }) => {
  return merchantApi.put({ url: '/merchant-api/order/update-price', data })
}

// 修改地址
export const updateAddress = (data: {
  id: number
  receiverName: string
  receiverMobile: string
  receiverAreaId: number
  receiverDetailAddress: string
}) => {
  return merchantApi.put({ url: '/merchant-api/order/update-address', data })
}

/** 导出本店订单（当前筛选） */
export const exportOrder = (params: any) => {
  return merchantApi.download({ url: '/merchant-api/order/export-excel', params })
}

/** 导出待发货发货清单（含可用物流公司 Sheet） */
export const exportDelivery = (params: any) => {
  return merchantApi.download({
    url: '/merchant-api/order/export-delivery',
    params,
    timeout: 30 * 60 * 1000
  })
}

export interface DeliveryImportFailure {
  rowIndex?: number
  orderNo?: string
  reason?: string
}

export interface DeliveryImportResult {
  successCount: number
  failureCount: number
  failures?: DeliveryImportFailure[]
}

/** 导入批量发货 Excel */
export const importDelivery = (formData: FormData) => {
  return merchantApi.upload<DeliveryImportResult>({
    url: '/merchant-api/order/import-delivery',
    data: formData,
    timeout: 30 * 60 * 1000
  })
}

/** 仅接受物流服务商确认的签收状态 */
export const syncOrderLogistics = (id: number) =>
  merchantApi.put({ url: '/merchant-api/order/sync-logistics', params: { id } })
